import { render, staticRenderFns } from "./ValidationDialog.vue?vue&type=template&id=09045828"
import script from "./ValidationDialog.vue?vue&type=script&lang=js"
export * from "./ValidationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports